module.exports = __webpack_public_path__ + "img/20220509.1ea1fc6d.png";